import $ from 'jquery';

export default abstract class UIElement {
  public readonly $element: JQuery<HTMLElement>;

  protected constructor(element: HTMLElement) {
    this.$element = $(element);
  }

  public abstract mount(): void;
}
